import {Dispatch} from "redux";
import {getContainer} from "../ioc/IOCSetup";
import {SettingsService} from "./SettingsService";
import {AppContext, CurrencyDefinition, MaintenanceAndServerTime, Settings} from "../http/protocol";
import { BalanceUpdateFrequency, defaultBalanceUpdateFrequency } from "../ui/BalanceUpdater";
import { AppState } from "../RootReducer";

export let lastBalanceUpdateFrequencyStatus: BalanceUpdateFrequency =
defaultBalanceUpdateFrequency;

export enum SettingsActionTypes {
    FETCH_SETTINGS_REQUEST = "@settings/fetch/request",
    FETCH_SETTINGS_SUCCESS = "@settings/fetch/response",
    FETCH_SETTINGS_ERROR = "@settings/fetch/error",
    SET_VIEW_SIZE_BR = "@settings/windowsize/set",
    TOGGLE_UPDATE_BALANCE = "@settings/updatebalance/toggle",
    SET_MOBILE_DEVICE =  "@settings/setmobiledevice",
    UPDATE_CURRENCIES = "@settings/updatecurrencies",
    MAINTENANCE_RESPONSE = "@settings/maintenance",
    COUNTRY = "@settings/country",
    JURISDICTION = "@settings/jurisdiction",
    COUNTRY_IS_BLOCKED = "@settings/setcountryisblocked",
    CHANGE_BALANCE_UPDATE_FREQUENCY = "@settings/change-balance-update-frequency",
    SET_APP_CONTEXT = "@settings/set-app-context"
}

export type SettingsActions =
    | { type : SettingsActionTypes.FETCH_SETTINGS_REQUEST }
    | { type : SettingsActionTypes.FETCH_SETTINGS_SUCCESS, contentModelName: string, payload: Settings }
    | { type : SettingsActionTypes.FETCH_SETTINGS_ERROR, payload: string }
    | { type : SettingsActionTypes.SET_VIEW_SIZE_BR, payload : {windowSize: number, mobile : boolean} }
    | { type : SettingsActionTypes.TOGGLE_UPDATE_BALANCE, payload: boolean}
    | { type : SettingsActionTypes.UPDATE_CURRENCIES, payload: CurrencyDefinition[]}
    | { type : SettingsActionTypes.COUNTRY, payload : string}
    | { type : SettingsActionTypes.JURISDICTION, payload : string}
    | { type : SettingsActionTypes.COUNTRY_IS_BLOCKED, payload : boolean}
    | { type : SettingsActionTypes.MAINTENANCE_RESPONSE, payload: MaintenanceAndServerTime}
    | { type : SettingsActionTypes.CHANGE_BALANCE_UPDATE_FREQUENCY, payload: BalanceUpdateFrequency}
    | { type : SettingsActionTypes.SET_APP_CONTEXT, payload: AppContext};

export const updateCountry = (country : string) => {
    return { type : SettingsActionTypes.COUNTRY, payload : country };
}
export const updateJurisdiction = (jurisdictionId : string) => {
    return { type : SettingsActionTypes.JURISDICTION, payload : jurisdictionId };
}
export const setCountryIsBlocked = (isBlocked: boolean) => {
    return { type : SettingsActionTypes.COUNTRY_IS_BLOCKED, payload : isBlocked };
}

export const fetchMaintenance = () => {
    return async  (dispatch : Dispatch) => {
        getContainer().getSettingsService().getMaintenance().then(mw => {
            dispatch({ type : SettingsActionTypes.MAINTENANCE_RESPONSE, payload : mw});
        })
    }
}
export const fetchSettings = () => {
    return async (dispatch: Dispatch) => {
        try {
            dispatch({type: SettingsActionTypes.FETCH_SETTINGS_REQUEST});
            let settingsService: SettingsService = getContainer().getSettingsService();
            let data;
            if(settingsService.getSettingsData() == undefined) {
                data = await settingsService.getSettings();
            } else {
                data = settingsService.getSettingsData()
            }
            dispatch({type: SettingsActionTypes.FETCH_SETTINGS_SUCCESS, payload: data});
        } catch(e) {
            dispatch({type: SettingsActionTypes.FETCH_SETTINGS_ERROR, error: e});
        }
    }
};

export const setWindowSizeBr = (windowSize : number, mobile : boolean) => {
    return { type : SettingsActionTypes.SET_VIEW_SIZE_BR, payload :  {windowSize : windowSize, mobile : mobile}};
};

export const setBalanceUpdateFrequency = (frequency : BalanceUpdateFrequency) => {
    return (dispatch : Dispatch, getState: () => AppState) => {
        const currentFrequency = getState().settings.balanceUpdateFrequency ?? defaultBalanceUpdateFrequency;

        lastBalanceUpdateFrequencyStatus = currentFrequency;
        dispatch({ type : SettingsActionTypes.CHANGE_BALANCE_UPDATE_FREQUENCY, payload : frequency});
    }
}

export const startBalanceUpdate = () => {
    return (dispatch: Dispatch, getState: () => AppState) => {
        const currentFrequency = getState().settings.balanceUpdateFrequency ?? defaultBalanceUpdateFrequency;
        if(currentFrequency === defaultBalanceUpdateFrequency) return;

        lastBalanceUpdateFrequencyStatus = currentFrequency;
        dispatch({ type : SettingsActionTypes.CHANGE_BALANCE_UPDATE_FREQUENCY, payload : defaultBalanceUpdateFrequency})
    }
}

export const stopBalanceUpdate = () => {
    return (dispatch: Dispatch, getState: () => AppState) => {
        const currentFrequency = getState().settings.balanceUpdateFrequency ?? defaultBalanceUpdateFrequency;
        if(currentFrequency === BalanceUpdateFrequency.STOPPED) return;

        lastBalanceUpdateFrequencyStatus = currentFrequency;
        dispatch({ type : SettingsActionTypes.CHANGE_BALANCE_UPDATE_FREQUENCY, payload : BalanceUpdateFrequency.STOPPED})
    }
}

export const setToLastBalanceUpdateFrequency = () => {
    return (dispatch: Dispatch, getState: () => AppState) => {
        const currentFrequency = getState().settings.balanceUpdateFrequency ?? defaultBalanceUpdateFrequency;
        if(currentFrequency === lastBalanceUpdateFrequencyStatus) return;

        dispatch({ type : SettingsActionTypes.CHANGE_BALANCE_UPDATE_FREQUENCY, payload : lastBalanceUpdateFrequencyStatus})
    }
}

export const setAppContext = (appContext: AppContext) => {
    return { type : SettingsActionTypes.SET_APP_CONTEXT, payload : appContext }
}